import { useApplicantContext } from '@/components/providers/ApplicantContextProvider';
import { useApplicantAssignees } from '@/components/shared/api/queries/assignees';
import { formatDateWithTimezone } from '@/components/shared/utils/utils';
import { ProductNameFields } from '@/components/providers/ApplicantContextProvider/ApplicantContextProvider.types';
import { DecisionDetailStatuses } from '../../Applicant.types';

export const PrintApplicationStatus = () => {
    const { applicant, applicantId, applicantPartnerId, applicantProductNames } = useApplicantContext();
    const { data: assignees } = useApplicantAssignees(applicantId ?? '');

    if (!applicant || applicantProductNames.length === 0) return null;

    return (
        <table className="print-status-table">
            <thead>
                <tr>
                    <th>Product</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Assigned To</th>
                </tr>
            </thead>
            <tbody>
                {applicantProductNames.map((product) => {
                    const productData = applicant[ProductNameFields[product]];
                    const status = (productData as { mostRecentDecisionDetail?: { status?: string; dateCreated?: string } })
                        ?.mostRecentDecisionDetail?.status ?? DecisionDetailStatuses.STARTED;
                    const dateCreated = (productData as { mostRecentDecisionDetail?: { dateCreated?: string } })
                        ?.mostRecentDecisionDetail?.dateCreated ?? '';
                    const assignee = assignees?.find(
                        (a) => String(a.product).toUpperCase() === product.toUpperCase(),
                    );
                    return (
                        <tr key={product}>
                            <td>{applicantPartnerId} {product}</td>
                            <td className="print-status-badge">{status}</td>
                            <td>{formatDateWithTimezone(dateCreated)}</td>
                            <td>{assignee?.email ?? '—'}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
